module.exports = __webpack_public_path__ + "static/media/Refreshimg.8adcedfe.svg";